<template>
  <div
    class="pagination"
  >
    <v-pagination
      v-bind="{
        totalVisible: 10,
        ...$props,
        ...$attrs,
      }"
    />
  </div>
</template>

<script>
export default {
  name: 'PaginationWrapper',
};
</script>

<style scoped lang="less">
.pagination {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 28px -8px 0px;
  height: 24px;
  max-height: 24px;
}

.pagination :deep(.v-pagination) li {
  margin: 0px 4px;
  button {
    box-shadow: none;
    background-color: transparent;
    border-radius: 5px;
    height: 24px;
    width: 24px;
    font-size: 12px;
    min-width: auto;
    font-weight: 300;
  }
}

.pagination :deep(.v-pagination) li button i {
  font-size: 20px;
}

.pagination :deep(.v-pagination) li.v-pagination__item--is-active button {
  color: @white;
  background-color: @text-brand;
  font-weight: 500;
  min-width: 24px;
  width: auto;
}
</style>
